
export const Z_MAP = {
  CANVAS: 0,
} as const;

export const Z_MAP_CONTROLS = {
  BASE: 100,
  ZOOM_BUTTONS: 100,
  COMPASS: 100,
  LOADING_INDICATOR: 150,
  SCALE_BAR: 100,
} as const;

export const Z_FIXED_PANELS = {
  BASE: 1000,
  SIDEBAR: 1000,
  SIDEBAR_TOGGLE: 1010,
  ATTRIBUTES_PANEL: 1030,
  RIGHT_TOOLS_PANEL: 1020,
  BOTTOM_PANEL: 1000,
  CONTEXT_MENU: 1050,
  SERVICE_POPUP: 1050,
} as const;

export const Z_DIALOGS = {
  BASE: 2000,
  MAX: 2999,
  BACKDROP: 1999,
  MOBILE_BACKDROP: 1999,
} as const;

export const Z_MODALS = {
  BASE: 3000,
  MAX: 3999,
  BACKDROP: 2999,
  MOBILE_BACKDROP: 2999,
  NESTED: 3001,
} as const;

export const Z_DROPDOWNS = {
  OFFSET: 1,
  FALLBACK: 5000,
  MAX_OFFSET: 100,
} as const;

export const Z_NOTIFICATIONS = {
  TOAST: 9000,
  CRITICAL_ALERT: 9500,
  CLIP_MASK: 9000,
} as const;

export const Z_INDEX = {
  MAP: Z_MAP,
  MAP_CONTROLS: Z_MAP_CONTROLS,
  FIXED_PANELS: Z_FIXED_PANELS,
  DIALOGS: Z_DIALOGS,
  MODALS: Z_MODALS,
  DROPDOWNS: Z_DROPDOWNS,
  NOTIFICATIONS: Z_NOTIFICATIONS,
} as const;

export type ZIndexLayer = keyof typeof Z_INDEX;
